import { useEffect } from 'react';
import { AuthenticatorType, useRepositoryMutation } from '@mews-commander/data-access';
import { LinkButton } from '@mews-commander/ui';
import { LocalizedText, showErrorAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Link } from '@optimus-web/core';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { TwoFactorForm, TwoFactorFormValues } from '../../components/TwoFactorForm';
import { authenticateWithSecondFactor } from '../../ducks/actions';
import { Configure2FALayout } from './Configure2FALayout';
import { use2FAEmailCode } from './use2FAEmailCode';

const actions = {
    primary: (
        <Button type="submit" size="medium" variant="primary">
            <LocalizedText textKey={TextKey.Activate} />
        </Button>
    ),
    secondary: (
        <LinkButton size="medium" to="/Home/Configure2FA/Index">
            <LocalizedText textKey={TextKey.GoBack} />
        </LinkButton>
    ),
};

export function Configure2FAEmail() {
    const { requestEmailAuthenticatorActivation, reRequestEmailAuthenticatorActivation } = use2FAEmailCode();

    const { onSubmit } = use2FASubmitHandler();

    useEffect(() => {
        requestEmailAuthenticatorActivation();
    }, [requestEmailAuthenticatorActivation]);

    return (
        <Configure2FALayout
            title={TextKey.TwoFactorAuthenticationVerifyEmailLabel}
            subtitle={TextKey.TwoFactorAuthenticationVerifyEmailDescription}
            extra={
                <Link onClick={reRequestEmailAuthenticatorActivation}>
                    <LocalizedText textKey={TextKey.ResendEmail} />
                </Link>
            }
        >
            <TwoFactorForm onSubmit={onSubmit} id="pin-email-form-settings" withPassword actions={actions} />
        </Configure2FALayout>
    );
}

function use2FASubmitHandler() {
    const dispatch = useCommanderThunkDispatch();
    const { mutateAsync } = useRepositoryMutation('users', 'updateAuthenticator', {
        meta: {
            disableDefaultErrorHandler: true,
        },
    });

    const onSubmit = async ({ pin, password = '' }: TwoFactorFormValues) => {
        // We remove spaces from the pin to ensure a better UX
        const cleanPin = pin.replace(/\s/g, '');
        try {
            await mutateAsync({
                authenticator: AuthenticatorType.Email,
                pin: cleanPin,
                password,
            });
            await dispatch(authenticateWithSecondFactor({ pin: cleanPin }));
        } catch (error) {
            showErrorAlert({ description: <>{error.message}</> });
        }
    };

    return { onSubmit };
}
